import script from "./AuctionSummary2.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionSummary2.vue?vue&type=script&setup=true&lang=js"

import "./AuctionSummary2.vue?vue&type=style&index=0&id=120b181a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120b181a"]])

export default __exports__